import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { EligibilityEventMeta } from '@models/profileConfiguration/model';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs';
import { EligibilityEventMetaStore, EventMetaState, EventMetaStoreState } from './eligibility-event-meta.store';

@Injectable({
  providedIn: 'root',
})
export class EligibilityEventMetaQuery extends QueryEntity<EventMetaStoreState> {
  protected store: EligibilityEventMetaStore;

  constructor() {
    const store = inject(EligibilityEventMetaStore);

    super(store);

    this.store = store;
  }

  public selectAllWhenLoaded(): Observable<EventMetaState[]> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.selectAll())
    );
  }

  public selectByEvent(eventId: string): Observable<EligibilityEventMeta> {
    return this.selectEntity(eventId).pipe(
      map((eventMeta) => {
        const meta = {
          ...eventMeta,
        };

        delete meta.id;

        return meta;
      })
    );
  }
}
